// constants.ts
import { PatternComponentType } from '@mrb91002/shared-types'

// Re-export for backward compatibility
export const EDIT_COMPONENT_TYPE = PatternComponentType

export const EDIT_COMPONENT_TYPE_TO_RENDER_COMPONENT = {
  [PatternComponentType.TEXT_LEFT_IMAGE_RIGHT]: 'TextLeftImageRightRender',
  [PatternComponentType.IMAGE_LEFT_TEXT_RIGHT]: 'ImageLeftTextRightRender',
  [PatternComponentType.MULTI_IMAGE]: 'MultiImageRender',
  [PatternComponentType.TIP]: 'PatternTip',
  [PatternComponentType.CAUTION]: 'PatternTip',
  [PatternComponentType.IMPORTANT]: 'PatternTip',
  [PatternComponentType.TEXT_ONLY]: 'TextOnlyRender',
}
